import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '../../../../../../components/global/Button';
import PinField from '../../../../../../components/global/PinField';
import { EVENTS } from '../../../../../../services/gtag/constants';
import useGtagManualTracking from '../../../../../../services/gtag/useGtagManualTracking';

const propTypes = {
  className: PropTypes.string,
  loading: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  values: PropTypes.shape({
    phone_number: PropTypes.string.isRequired,
  }).isRequired,
  onPinCodeResend: PropTypes.func.isRequired,
};

const RegistrationEmailPinVerify = ({
  className,
  loading,
  handleSubmit,
  handleChange,
  onPinCodeResend,
  values,
}) => {
  const { onTrackEvent } = useGtagManualTracking();
  const classes = classNames({
    [className]: !!className,
  });

  const isValid = values.code?.length === 4;

  return (
    <div className={classes}>
      <form
        onSubmit={e => {
          onTrackEvent({
            event: EVENTS.CLICK_VERIFY_PIN_CODE,
            data: {
              page_title: 'Complete Consumer Pin Auth',
            },
          });

          handleSubmit(e);
        }}
      >
        <div className="mb-3">
          <PinField
            className="registration-pin-field registration-pin-input"
            onComplete={value => {
              handleChange({
                target: {
                  name: 'code',
                  value,
                },
              });
            }}
            onChange={value => {
              handleChange({
                target: {
                  name: 'code',
                  value,
                },
              });
            }}
          />
        </div>

        <div>
          <Button
            type="submit"
            disabled={loading || !isValid}
            loading={loading}
            className="d-block mt-2"
          >
            {loading ? 'Processing...' : 'Verify Pin Code'}
          </Button>
          <Button
            type="button"
            btnStyle="link"
            disabled={loading}
            loading={loading}
            className="d-block mt-2"
            onClick={() => onPinCodeResend(values)}
          >
            Re&ndash;send code
          </Button>
        </div>
      </form>
    </div>
  );
};

RegistrationEmailPinVerify.propTypes = propTypes;

export default RegistrationEmailPinVerify;
